// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `tbody.runtimes-override-table-body > tr:nth-child(even) > td {
  background-color: #F4F4F4;
}

tbody.runtimes-override-table-body > tr:nth-child(odd) > td {
  background-color: white;
}

.runtimes-override-table-head th {
  background-color: #004B22;
  color: #fff;
}

.runtimes-override-edit {
  outline: none !important;
}`, "",{"version":3,"sources":["webpack://./src/style/RuntimesOverrideTable.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;AACJ;;AAEA;EACI,uBAAA;AACJ;;AAEA;EACI,yBAAA;EACA,WAAA;AACJ;;AAEA;EACI,wBAAA;AACJ","sourcesContent":["tbody.runtimes-override-table-body > tr:nth-child(even) > td {\n    background-color: #F4F4F4;\n}\n\ntbody.runtimes-override-table-body > tr:nth-child(odd) > td {\n    background-color: white;\n}\n\n.runtimes-override-table-head th {\n    background-color: #004B22;\n    color: #fff;\n}\n\n.runtimes-override-edit {\n    outline: none !important; \n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
